// Temporary UI-side Missions gateway facade that delegates to existing API.
// Replace with shared MissionsGateway once Agent A lands it.

import type { Mission, MissionLead } from '../api/missions';
import {
  listMissions as listMissionsApi,
  getMission as getMissionApi,
  createMission as createMissionApi,
  updateMission as updateMissionApi,
  deleteMission as deleteMissionApi,
  listMissionLeads as listMissionLeadsApi,
  assignLeadsToMission as assignLeadsToMissionApi,
  reorderMissionLead as reorderMissionLeadApi,
  updateMissionLead as updateMissionLeadApi,
  deleteMissionLead as deleteMissionLeadApi,
} from '../api/missions';

export interface MissionsGateway {
  listMissions: (email?: string, role?: 'Admin' | 'Sales' | 'Viewer') => Promise<Mission[]>;
  getMission: (id: string) => Promise<Mission | null>;
  createMission: (payload: Omit<Mission, 'id'>) => Promise<Mission>;
  updateMission: (id: string, updates: Partial<Mission>) => Promise<Mission>;
  deleteMission: (id: string) => Promise<void>;
  listMissionLeads: (missionId: string, opts?: { signal?: AbortSignal }) => Promise<MissionLead[]>;
  assignLeadsToMission: (missionId: string, leadIds: string[]) => Promise<MissionLead[]>;
  reorderMissionLead: (missionId: string, missionLeadId: string, targetIndex: number) => Promise<MissionLead[]>;
  updateMissionLead: (missionLeadId: string, patch: Partial<MissionLead>) => Promise<MissionLead>;
  deleteMissionLead: (missionLeadId: string) => Promise<void>;
}

export const missionsGateway: MissionsGateway = {
  async listMissions(email, role) {
    return listMissionsApi(email, role);
  },
  async getMission(id) {
    return getMissionApi(id);
  },
  async createMission(payload) {
    return createMissionApi(payload);
  },
  async updateMission(id, updates) {
    return updateMissionApi(id, updates);
  },
  async deleteMission(id) {
    return deleteMissionApi(id);
  },
  async listMissionLeads(missionId, opts) {
    return listMissionLeadsApi(missionId, opts);
  },
  async assignLeadsToMission(missionId, leadIds) {
    return assignLeadsToMissionApi(missionId, leadIds);
  },
  async reorderMissionLead(missionId, missionLeadId, targetIndex) {
    return reorderMissionLeadApi(missionId, missionLeadId, targetIndex);
  },
  async updateMissionLead(missionLeadId, patch) {
    return updateMissionLeadApi(missionLeadId, patch);
  },
  async deleteMissionLead(missionLeadId) {
    return deleteMissionLeadApi(missionLeadId);
  },
};

